import React, { useEffect, useRef, useState } from 'react';
import { injectIntl } from 'react-intl';
import { Col, Row } from 'reactstrap';
import {
  extractIds,
  getCurrencySuffix,
  getImageUrl,
  getImageVariant,
  getLocalizedName,
  anyConfigHasPosIntegration,
} from '../../../../utility/util/util.service';
import { AvInput, AvForm } from 'availity-reactstrap-validation';
import LocalizedNameField from '../../form/fields/LocalizedNameField';
import ImageDropzoneComponent from '../../form/dropzones/image-dropzone/image-dropzone.component';
import SaveSubmitButton from '../../form/buttons/SaveSubmitButton';
import TaxInhouseField from '../../form/fields/TaxInhouseField';
import { connect } from 'react-redux';
import IngredientsField from '../../form/fields/IngredientsField';
import AllergensField from '../../form/fields/AllergensField';
import PreferencesField from '../../form/fields/PreferencesField';
import {
  closeModalSafely,
  getTranslationsCollapsable,
  handleSubmit,
  getOrderConditionsCollapsable,
} from './create-or-edit-item-data.service';
import DefaultAlertComponent from '../../alerts/default-alert/default-alert.component';
import PropTypes from 'prop-types';
import ModalSheet from '../modal-sheet/modal-sheet.component';
import {
  fetchAdditionGroups,
  fetchFoodItemAdditions,
  fetchItemDatas,
  fetchMenuEntries,
  fetchMenuItems,
} from '../../../../redux/store/store.actions';
import {
  execOnSuccess,
  setIsCreateItemModalOpen,
  setIsEditItemModalOpen,
  setEditItemModalData,
  setCreateItemModalData,
} from '../../../../redux/modal/modal.actions';
import KcalField from '../../form/fields/KcalField';
import PosIntegrationRefField from '../../form/fields/PosIntegrationRefField';
import TextEditorField from '../../form/fields/TextEditorField';
import SmartSchankPluField from '../../form/fields/SmartSchankPluField';
import AdditivesField from '../../form/fields/AdditivesField';
import TaxTakeawayField from '../../form/fields/TaxTakeawayField';
import DefaultCourseField from '../../form/fields/DefaultCourseField';
import PosIntegrationBoundAdditionsField from '../../form/fields/PosIntegrationBoundAdditionsField';
import FormField from '../../form/fields/FormField';
import AdditionGroupsField from '../../form/fields/AdditionGroupsField';
import FormattedNumberField from '../../form/fields/FormattedNumberField';
import DropdownField from '../../form/fields/DropdownField';
import LabeledToggle from '../../form/LabeledToggle';

const CreateOrEditItemDataModal = ({
  isCreateItemModalOpen,
  isEditItemModalOpen,
  createItemModalData,
  editItemModalData,
  editItemModalDataAvailableAt,
  allAllergens,
  allPreferences,
  allIngredients,
  allAdditions,
  allAdditives,
  menu,
  intl,
  store,
  additionGroups,
  pickupStations,

  fetchMenuEntries,
  setIsCreateItemModalOpen,
  setIsEditItemModalOpen,
  setCreateItemModalData,
  setEditItemModalData,
  fetchAdditionGroups,
  fetchFoodItemAdditions,
  fetchItemDatas,
  fetchMenuItems,
}) => {
  const [targetItemData, setTargetItemData] = useState({});
  const [serviceTimesLocalState, setServiceTimesLocalState] = useState([[]]);
  const [uploadImage, setUploadImage] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isActive, setIsActive] = useState(true);
  const [isTranslationsOpen, setIsTranslationsOpen] = useState(false);
  const [isOrderConditionsOpen, setIsOrderConditionsOpen] = useState(false);
  const [targetOrderConditions, setTargetOrderConditions] = useState([]);
  const [isAddOrderConditionOpen, setIsAddOrderConditionOpen] = useState(false);
  const [selectedOrderCondition, setSelectedOrderCondition] = useState(null);
  const [newOrderCondition, setNewOrderCondition] = useState({
    isActive: true,
    priority: 10,
    minTotal: 0,
    maxTotal: null,
    minQty: 0,
    maxQty: null,
    limitMode: null, limits: [], staticLimit: null, staticRemaining: null,
    classes: ['inhouse', 'takeaway'],
  });

  const isOpen = isCreateItemModalOpen || isEditItemModalOpen;
  const isEditMode = isEditItemModalOpen;
  const isCreateMode = isCreateItemModalOpen;
  const {
    isVariation,
    itemData, // only mandatory when isEditMode=true
    targetCategoryId, // only mandatory isCreateMode=true && isVariation=false
    targetItemId, // only mandatory isCreateMode=true && isVariation=true
    onSuccess,
  } = (isCreateMode ? createItemModalData : editItemModalData) || {};
  const formRef = useRef(null);

  const closeModal = () => {
    setIsOrderConditionsOpen(false);
    setIsAddOrderConditionOpen(false);
    setTargetItemData({});
    setTargetOrderConditions([]);
    setServiceTimesLocalState([[]]);
    setSelectedOrderCondition(null);
    setNewOrderCondition({
      priority: null,
      minTotal: 0,
      maxTotal: null,
      minQty: 0,
      maxQty: null,
      limitMode: null, limits: [], staticLimit: null, staticRemaining: null,
      classes: ['inhouse', 'takeaway'],
    });
    isCreateItemModalOpen
      ? setIsCreateItemModalOpen(false)
      : setIsEditItemModalOpen(false);
    setCreateItemModalData(null);
    setEditItemModalData(null);
  };
  const userLocale = intl?.locale;
  const modalTitleId = isEditMode
    ? isVariation
      ? 'editVariationTitle'
      : 'editItemTitle'
    : isVariation
    ? 'createVariationTitle'
    : 'createItemTitle';

  useEffect(() => {
    if (isOpen) {
      // reset modal on opening
      if (itemData) {
        setIsActive(itemData?.isActive);
      }
      setTargetItemData(
        (itemData && {
          ...itemData,
          targetItemId,
          //ingredientIds: extractIds(itemData.ingredients),
          preferenceIds: extractIds(itemData.preferences),
          allergenIds: extractIds(itemData.allergens),
          additionIds: extractIds(itemData.additions),
        }) ||
          {},
      );
      setUploadImage(null);
      const variant = getImageVariant('menuEntry');
      setPreviewUrl(getImageUrl(itemData?.image, variant) || null);
      setTargetOrderConditions(itemData?.orderConditions);
    } else {
      // reset modal on closing
      setUploadImage(null);
      setPreviewUrl(null);
      setTargetItemData({});
      setCreateItemModalData(null);
      setEditItemModalData(null);
    }
  }, [itemData, isOpen, store]);

  const _closeModalSafely = () => closeModalSafely(isSubmitting, closeModal);
  const _handleSubmit = (event, errors, values) => {
    handleSubmit(
      event,
      errors,
      values,
      uploadImage,
      { ...targetItemData, isActive },
      isEditMode,
      isVariation,
      setIsSubmitting,
      setTargetItemData,
      closeModal,
      async () => {
        const menuId = store?.menu?.id;
        const storeId = store?.id;
        await Promise.all([
          fetchFoodItemAdditions(true, menuId, undefined, storeId),
          fetchMenuItems(true, menuId, undefined, storeId),
          fetchItemDatas(true, menuId, undefined, storeId),
        ]);
        await fetchAdditionGroups(true, menuId, undefined, storeId);
        return new Promise((resolve, reject) => {
          fetchMenuEntries(
            menuId,
            true,
            () => {
              execOnSuccess(onSuccess);
              resolve(setServiceTimesLocalState); // Resolve the promise with setServiceTimesLocalState
            },
            storeId,
          );
        });
      },
      targetOrderConditions,
      newOrderCondition,
      isAddOrderConditionOpen,
      store?.id,
    );
  };

  const _getTranslationsCollapsable = () =>
    getTranslationsCollapsable(
      targetItemData,
      isTranslationsOpen,
      setIsTranslationsOpen,
      true,
      true,
      userLocale,
      true,
      false,
      setTargetItemData,
    );

  const _getOrderConditionsCollapsable = () =>
    getOrderConditionsCollapsable(
      targetOrderConditions,
      setTargetOrderConditions,
      isOrderConditionsOpen,
      setIsOrderConditionsOpen,
      userLocale,
      isSubmitting,
      intl,
      isAddOrderConditionOpen,
      setIsAddOrderConditionOpen,
      newOrderCondition,
      setNewOrderCondition,
      'orderConditionsTitle',
      true,
      selectedOrderCondition,
      setSelectedOrderCondition,
      true,
    );

  return (
    <ModalSheet
      isOpen={isOpen}
      closeModal={_closeModalSafely}
      title={intl.formatMessage({ id: modalTitleId })}
      onSpringCancel={_closeModalSafely}
      footer={
        <div className="align-content-center">
          <SaveSubmitButton
            data-testid="submitItemButton"
            className="m-auto"
            isSubmitting={isSubmitting}
            onClick={() => formRef?.current.handleSubmit()}
          />
        </div>
      }
    >
      <div className="px-1">
        {isCreateMode && isVariation && (
          <DefaultAlertComponent
            msg={intl.formatMessage(
              { id: 'createNewItemVariationCopiedDataAlert' },
              { itemName: getLocalizedName(itemData, intl.locale) },
            )}
          />
        )}
        <AvForm ref={formRef} onSubmit={_handleSubmit} disabled={isSubmitting}>
          <div className="mt-2">
            {isCreateMode && isVariation && (
              <AvInput name="itemId" value={targetItemId} hidden />
            )}
            {isCreateMode && !isVariation && (
              <AvInput
                name="categoryIds"
                value={targetCategoryId ? [targetCategoryId] : null}
                hidden
              />
            )}
            <LabeledToggle
              disabled={isSubmitting}
              checked={isActive}
              onClick={() => setIsActive(!isActive)}
              wrapperClassName="d-flex align-content-center justify-content-between mt-2 mb-2"
              headingMessageId="isActiveLabel"
              headingClassName="d-block black"
            />
            <LocalizedNameField
              data-testid="nameInputItem"
              object={targetItemData}
              locale={userLocale?.substring(0, 2)}
              required
            />
            <TextEditorField
              object={targetItemData}
              locale={userLocale?.substring(0, 2)}
              setter={setTargetItemData}
              isDisabled={isSubmitting}
            />
            <FormField
              data-testid="manualRankingInput"
              object={targetItemData}
              propertyName="manualRanking"
              type="number"
              validate={{ number: true }}
              valueParser={(value) => {
                const parsedValue = parseInt(value);
                return parsedValue || undefined;
              }}
              messageId="manualRankingLabel"
            />
            <Row>
              <Col xs={6} className="pr-50">
                <FormattedNumberField
                  propName="priceInhouse"
                  object={targetItemData}
                  suffixSign={getCurrencySuffix(store?.currency)}
                />
              </Col>
              <Col xs={6} className="pl-50">
                <TaxInhouseField
                  data-testid="taxInhouse"
                  object={targetItemData}
                />
              </Col>
            </Row>
            <Row>
              <Col xs={6} className="pr-50">
                <FormattedNumberField
                  propName="priceTakeaway"
                  object={targetItemData}
                  suffixSign={getCurrencySuffix(store?.currency)}
                />
              </Col>
              <Col xs={6} className="pl-50">
                <TaxTakeawayField
                  data-testid="taxTakeaway"
                  object={targetItemData}
                />
              </Col>
            </Row>
            <Row>
              <Col xs={6} className="pr-50">
                <KcalField
                  data-testid="caloriesField"
                  object={targetItemData}
                />
              </Col>
              <Col xs={6} className="pl-50">
                <DefaultCourseField
                  data-testid="courseField"
                  object={targetItemData}
                />
              </Col>
            </Row>
            {/* <IngredientsField
              object={targetItemData}
              setter={setTargetItemData}
              options={allIngredients || []}
              isDisabled={isSubmitting}
            /> */}
            <AllergensField
              object={targetItemData}
              setter={setTargetItemData}
              options={allAllergens || []}
              isDisabled={isSubmitting}
            />
            <PreferencesField
              object={targetItemData}
              setter={setTargetItemData}
              options={allPreferences || []}
              isDisabled={isSubmitting}
            />
            <AdditionGroupsField
              propertyName="additionGroupIds"
              object={targetItemData}
              setter={setTargetItemData}
              options={additionGroups || []}
              isDisabled={isSubmitting}
              store={store}
            />
            <AdditivesField
              object={targetItemData}
              setter={setTargetItemData}
              options={allAdditives || []}
              isDisabled={isSubmitting}
            />
            {anyConfigHasPosIntegration(store) && (
              <PosIntegrationRefField
                placeholder={intl.formatMessage({
                  id: 'selectPosIntegrationRefLabel',
                })}
                type="item"
                propertyName="posIntegrationRef"
                object={targetItemData}
                setter={setTargetItemData}
              />
            )}
            {anyConfigHasPosIntegration(store) && (
              <PosIntegrationBoundAdditionsField
                object={targetItemData}
                setter={setTargetItemData}
                options={allAdditions || []}
                isDisabled={isSubmitting}
                store={store}
              />
            )}
            {/*  <DropdownField
              isMulti={true}
              options={pickupStations?.map((pickupStation) => {
                return {
                  value: pickupStation,
                  label: pickupStation?.name,
                };
              })}
              propertyName="pickupStations"
              object={targetItemData}
              placeholderMessageId="pickupStationsLabel"
              labelMessageId="pickupStationsTitle"
            /> */}
            {store?.peripheralIntegrations?.find(
              (integration) =>
                integration?.type === 'SmartSchankPeripheralIntegration',
            ) && <SmartSchankPluField object={targetItemData} />}
            <ImageDropzoneComponent
              propertyName="image"
              object={targetItemData}
              setter={setTargetItemData}
              previewUrl={previewUrl}
              setPreviewUrl={setPreviewUrl}
              setUploadImage={setUploadImage}
              isDisabled={isSubmitting}
            />
            {_getTranslationsCollapsable()}
            {_getOrderConditionsCollapsable()}
          </div>
        </AvForm>
      </div>
    </ModalSheet>
  );
};

CreateOrEditItemDataModal.propTypes = {
  isCreateItemModalOpen: PropTypes.bool,
  isEditItemModalOpen: PropTypes.bool,
  createItemModalData: PropTypes.object,
  editItemModalData: PropTypes.object,
  editItemModalDataAvailableAt: PropTypes.object,
  allAllergens: PropTypes.array,
  allPreferences: PropTypes.array,
  allIngredients: PropTypes.array,
  allAdditions: PropTypes.array,
  intl: PropTypes.object,
  menu: PropTypes.object,
  fetchMenuEntries: PropTypes.func,
  setIsCreateItemModalOpen: PropTypes.func,
  setIsEditItemModalOpen: PropTypes.func,
};

const mapStateToProps = (state) => ({
  isCreateItemModalOpen: state.modals.isCreateItemModalOpen,
  isEditItemModalOpen: state.modals.isEditItemModalOpen,
  createItemModalData: state.modals.createItemModalData,
  editItemModalData: state.modals.editItemModalData,
  editItemModalDataAvailableAt: state.modals.editItemModalDataAvailableAt,
  allAdditions: state.store.foodItemAdditions,
  allAllergens: state.store.foodAllergens,
  allPreferences: state.store.foodPreferences,
  allIngredients: state.store.foodIngredients,
  allAdditives: state.store.foodAdditives,
  menu: state.store.menu,
  store: state.store.store,
  additionGroups: state.store.additionGroups,
  pickupStations: state.store.pickupStations,
});

export default connect(mapStateToProps, {
  fetchMenuEntries,
  setIsCreateItemModalOpen,
  setIsEditItemModalOpen,
  setCreateItemModalData,
  setEditItemModalData,
  fetchAdditionGroups,
  fetchFoodItemAdditions,
  fetchItemDatas,
  fetchMenuItems,
})(injectIntl(CreateOrEditItemDataModal));
